module.exports = ":host /deep/ table *,\n:host /deep/ #example {\n    border: none !important;\n}\n\n.download-certificate {\n    background: none;\n    color: #8e8fa6;\n    font-size: 14px;\n}\n\n.filters {\n    margin-top: 10px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/certificates/components/details/certificates-issued/certificates-issued.component.css
// module id = ./src/app/organization/components/certificates/components/details/certificates-issued/certificates-issued.component.css
// module chunks = main